import { useEffect, useState } from 'react';
import { fetchProducts, createInvoice, type ProductView } from '../api';

interface Props {
  onAfterBuy?: () => void;
}

export function Shop({ onAfterBuy }: Props) {
  const [products, setProducts] = useState<ProductView[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [buying, setBuying] = useState<string | null>(null);

  useEffect(() => {
    fetchProducts()
      .then((r) => setProducts(r.products))
      .catch((e) => setErr(String(e)));
  }, []);

  async function buy(id: string) {
    setBuying(id);
    setErr(null);
    try {
      const { invoiceLink } = await createInvoice(id);
      // Telegram in-app invoice flow. openInvoice requires the URL from
      // createInvoiceLink (a t.me/invoice/<slug> URL).
      const tg = window.Telegram?.WebApp;
      if (tg?.openInvoice) {
        tg.openInvoice(invoiceLink, () => {
          // Telegram fires the callback with status strings ('paid', 'cancelled', ...).
          // We just refresh — the server knows the truth via successful_payment.
          fetchProducts().then((r) => setProducts(r.products)).catch(() => {});
          onAfterBuy?.();
        });
      } else {
        // Desktop fallback (user running in a regular browser somehow).
        window.open(invoiceLink, '_blank', 'noopener');
      }
    } catch (e) {
      setErr(String(e));
    } finally {
      setBuying(null);
    }
  }

  if (err) return <div className="card muted">— {err}</div>;
  if (!products) return <div className="card muted">…</div>;

  return (
    <div>
      {products.map((p) => (
        <div key={p.id} className="card shop-item">
          <div className="shop-item-head">
            <span className="shop-emoji" aria-hidden>{p.emoji}</span>
            <div style={{ flex: 1 }}>
              <div className="shop-title">{p.title}</div>
              <div className="shop-desc">{p.description}</div>
            </div>
          </div>
          <div className="shop-row">
            <div className="shop-price">
              {p.priceStars} ⭐
              {p.recurring && <span className="shop-period"> / 30 dni</span>}
            </div>
            <button
              className="btn shop-buy"
              disabled={p.owned || buying === p.id}
              onClick={() => buy(p.id)}
            >
              {p.owned ? '✓' : buying === p.id ? '…' : 'Kup'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
